import React, { useState, useEffect } from 'react';
import { StyledBroadsiderPromo } from './BroadsiderPromo.styled';
import { AppCarousel } from '../';

const BroadsiderPromoDots = ({ items = [], currentIndex = null}) => {
  return (
    <div className='broadsider-promo-dots-container'>
      {items.map((i, index) => (<div key={index} className={`broadsider-promo-dot${index === currentIndex ? ' broadsider-promo-dot-current': ''}`}/>))}
    </div>
  );
};

const BroadsiderPromo = ({ children, period = 10000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (children && children.length > 0) {
      const intervalId = setInterval(() => {
        setCurrentIndex((currentIndex + 1) % children.length);
      }, period);
      return () => clearInterval(intervalId);
    }
  }, [currentIndex, children]);

  return (
    <StyledBroadsiderPromo>
      <div className='broadsider-promo-content' >
        <AppCarousel currentIndex={currentIndex}>
          {children}
        </AppCarousel>
      </div>
      <BroadsiderPromoDots items={children} currentIndex={currentIndex}/>
      <div className='broadsider-promo-corner broadsider-promo-corner-tl' />
      <div className='broadsider-promo-corner broadsider-promo-corner-tr' />
      <div className='broadsider-promo-corner broadsider-promo-corner-bl' />
      <div className='broadsider-promo-corner broadsider-promo-corner-br' />
      {currentIndex > 0 && (<div className='broadsider-promo-prev' onClick={() => setCurrentIndex(currentIndex - 1)} />)}
      {currentIndex < children.length - 1 && (<div className='broadsider-promo-next' onClick={() => setCurrentIndex(currentIndex + 1)} />)}
    </StyledBroadsiderPromo>
  )
};

export default BroadsiderPromo;
